import { render, staticRenderFns } from "./indent.vue?vue&type=template&id=4237c083&"
import script from "./indent.vue?vue&type=script&lang=js&"
export * from "./indent.vue?vue&type=script&lang=js&"
import style0 from "./indent.vue?vue&type=style&index=0&id=4237c083&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports